/**
 * Background color options for the SelectInput component.
 * @module selectInputColorOptions
 * @category FormInputs
 * @author Dan Levy <danlevy124@gmail.com>
 */

/**
 * White background color
 * @type {string}
 */
export const WHITE = "white";

/**
 * Primary blue background color
 * @type {string}
 */
export const PRIMARY_BLUE = "primaryBlue";

/**
 * Green background color
 * @type {string}
 */
export const GREEN = "green";

/**
 * Orange background color
 * @type {string}
 */
export const ORANGE = "orange";

/**
 * Red background color
 * @type {string}
 */
export const RED = "red";
